import React from 'react';

const NotFoundPage = () => {
  return (
    <iframe
      src="/404.html"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
      title="404 Page Not Found"
    />
  );
};

export default NotFoundPage;
